import React from 'react';
import {Card, Col, Row, Typography} from 'antd';
import PropTypes from "prop-types";

import ErrorBoundary from '../ErrorBoundary';

const {Text} = Typography;

const AccountBusinessDetails = ({companyData}) => {
    return (
        <Card
            title={<><span>Business Details</span></>}
            className="business-details-card"
        >
            <ErrorBoundary>
                <Row>
                    <Col span={24}>
                        <span><Text strong>Business Name:</Text></span>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.business_name ? companyData.business_name : 'N/A'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>DBA Name:</Text></span>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.dba_name ? companyData.dba_name : 'N/A'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>Website Address:</Text></span>
                    </Col>
                    <Col span={24}>
                        {
                            companyData.website_address ?
                                <Text className="long-text-wrap">{companyData.website_address}</Text>
                                :
                                'N/A'
                        }
                    </Col>
                </Row>
            </ErrorBoundary>
        </Card>
    );
}

AccountBusinessDetails.propTypes = {
    companyData: PropTypes.object.isRequired,
};

export default AccountBusinessDetails;
